import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { springVariants, rightVariants, leftVariants, springViewport } from '../utils/framerVariants';
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Highlight = ({ data }) => {
  const hasSpacing = data.ComponentMargins && data.ComponentMargins.startsWith("None");
  const isDownloadAvailable = data.Download && data.Download.file.url;
  const isPreviewAvailable = data.HighlightPreviews && data.HighlightPreviews.file;

  return (
    <div className={`a${data.id} accordeon-wrap container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl  sm:px-24 md:px-48 lg:px-64 ${hasSpacing ? "mb-4" : "mb-16 md:mb-24 lg:mb-32 xl:mb-48"}`}>
      {data.LinkURL && (
        <a href={data.LinkURL} target={`_${data.LinkTargets}`}>
          <motion.div
            variants={springVariants}
            initial="invisible"
            whileInView="visible"
            viewport={springViewport}
            className="accordeon-panel"
          >
            {isPreviewAvailable && (
              <div className="header">
                <div className="p-8 md:p-12">
                  {data.Subheadline && <p className="accordeon-title mb-2 md:mb-4 max-w-xl">{data.Subheadline}</p>}
                  {data.Headline && <h2 className="accordeon-title text-headline tracking-headline leading-headline font-bold max-w-xs md:max-w-xl 2xl:max-w-2xl pr-12">{data.Headline}</h2>}
                </div>
                <div className="relative z-10">
                  <GatsbyImage
                    image={getImage(data.HighlightPreviews.file)}
                    alt={data.HighlightPreviews?.alternativeText || ""}
                  />
                </div>
              </div>
            )}
            {!isPreviewAvailable && (
              <div className="header p-8 md:p-12">
                {data.Subheadline && <p className="accordeon-title mb-4 max-w-xl">{data.Subheadline}</p>}
                {data.Headline && <h2 className="accordeon-title text-headline tracking-headline leading-headline font-bold max-w-xs md:max-w-xl 2xl:max-w-2xl pr-12">{data.Headline}</h2>}
              </div>
            )}
            <div className="absolute top-4 md:top-6 right-6 md:right-8 highlight-icons">
              <svg className="w-5 md:w-6 lg:w-6 stroke-white" viewBox="0 0 28 27" xmlns="http://www.w3.org/2000/svg">
                <g strokeWidth="3" fill="none" fillRule="evenodd" strokeLinecap="square">
                  <path d="m17 5 8.502 8.468M3 13l19.998.251M17 21.952l8.467-8.503"/>
                </g>
              </svg>
            </div>
          </motion.div>
        </a>
      )}

      {isDownloadAvailable && (
        <a href={data.Download.file.url} target={`_${data.LinkTargets}`}>
          <motion.div
            variants={springVariants}
            initial="invisible"
            whileInView="visible"
            viewport={springViewport}
            className="accordeon-panel download"
          >
            <div className="header p-8 md:p-12">
              {data.Subheadline && <p className="accordeon-title mb-4 pr-12 md:pr-24">{data.Subheadline}</p>}
              {data.Headline && <h2 className="accordeon-title text-headline tracking-headline leading-headline font-bold pr-16">{data.Headline}</h2>}
              {isPreviewAvailable && (
                <GatsbyImage
                  className="mt-12"
                  image={getImage(data.HighlightPreviews.file)}
                  alt={data.HighlightPreviews?.alternativeText}
                />
              )}
            </div>
            <div className="absolute top-4 md:top-6 right-6 md:right-7 highlight-icons">
              <svg className="rotate-90 w-5 md:w-6 lg:w-6 stroke-white" viewBox="0 0 28 27" xmlns="http://www.w3.org/2000/svg">
                <g strokeWidth="3" fill="none" fillRule="evenodd" strokeLinecap="square">
                  <path d="m17 5 8.502 8.468M3 13l19.998.251M17 21.952l8.467-8.503"/>
                </g>
              </svg>
            </div>
          </motion.div>
        </a>
      )}
    </div>
  );
}

export default Highlight;
